import * as _ from "lodash";
import {BaseInternalView, BaseInternalViewOptions} from "../views/_BaseViews";
import {AppCollection} from "../collections/Apps";
import {AppNotEnabledView, BaseAppView} from "./_BaseAppViews";
import {BaseModifyDashboardWidgetViewOptions} from "../views/modals/dashboard/modify_widgets/_BaseModifyWidgetView";
import {BaseDashboardWidgetViewOptions} from "../views/dashboard/widgets/_BaseWidgetView";
import {TeamDetailViewOptions} from "../views/account/team/TeamDetailViews";
import {BaseCollection} from "../collections/_BaseCollection";

export interface BaseAppOptions extends BaseInternalViewOptions {
    appCollection: AppCollection;
}

export interface AccountPageInfo {
    count: number;
    name: string;
    icon: string;
    type: string
}


export abstract class BaseApp extends BaseInternalView {

    public options: BaseAppOptions;

    protected lastView: BaseAppView = null;

    constructor(options: BaseAppOptions) {
        super(options);
    }

    abstract getAppName(): string;

    abstract getAppType(): string;

    abstract getRoutes(): { [key: string]: () => BaseAppView };

    abstract getRootView(): BaseAppView;

    abstract getNavView(): BaseAppView;

    abstract getGroupNavView(): BaseAppView;

    protected checkAppEnabled(func: (...args) => BaseAppView, ...args): BaseAppView {
        var appId = Number(args[0]);
        var app = this.options.appCollection.findWhere({id: appId, enabled: 1});

        if (!app) {
            if (this.lastView) this.lastView.remove();
            this.lastView = new AppNotEnabledView(_.extend({}, this.options, {
                appController: this
            }));
            return this.lastView;
        }

        return func(...args);
    }

    remove() {
        // Remove listeners from the global event bus
        this.stopListening();

        return super.remove();
    }

    getWidgetModifyViewByTypeId(widgetId: number, options: BaseModifyDashboardWidgetViewOptions) {
        return $.Deferred().resolve()
    }

    getWidgetView(options: BaseDashboardWidgetViewOptions) {
        return $.Deferred().resolve()
    }

    getPermissionSectionView(options: TeamDetailViewOptions) {
        return $.Deferred().resolve()
    }

    getPermissionPreview(options: TeamDetailViewOptions) {
        return $.Deferred().resolve()
    }

    getAppId(organizationId) {
        var appId = null;
        this.options.appCollection.each((app) => {
            if(app.get('organization_id') === Number(organizationId)
                && app.get('type') === this.getAppType()){
                appId = app.get('id')
            }
        });
        return appId;
    }

    getAccountView(options) {
        return $.Deferred().resolve();
    }

    getChannelCollectionPromiseForInstallAccountPage(organizationId) {
        return $.Deferred().resolve(new BaseCollection([]))
    }

    getAccountPage() {
        return $.Deferred().resolve({
            name: 'base app',
            count: 100,
            icon: require('../../img/apps/controls/controls-nav.svg')
        });
    }

    static makeAppPermissionCollection(collectionInstance, appPermissionCollectionClass) {
        var newMembers = _.pickBy(new appPermissionCollectionClass(), (i, k) => {
            return _.isFunction(i) && i['isPermissionFunction'] && !_.has(collectionInstance, k);
        });
        _.each(newMembers, (v, k) => {
            collectionInstance[k] = v.bind(collectionInstance);
        });
    }
}

// Required so we can dynamically require apps by the class name App
export class App extends BaseApp {
    getAppName() {
        return "BaseApp"
    }

    getAppType() {
        return "app"
    }

    getRoutes() {
        return {}
    }

    getRootView() {
        return new BaseAppView(_.extend({}, this.options, {appController: this}))
    }

    getNavView() {
        return new BaseAppView(_.extend({}, this.options, {appController: this}))
    }

    getGroupNavView() {
        return new BaseAppView(_.extend({}, this.options, {appController: this}))
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/apps/_BaseApp.ts